import util from "@/assets/js/common/util";
import tracker from "@/assets/js/statistics/xkw.tracker";
import { deleteBook, getUserMode } from "@/utils/apis";
import { Message } from "element-ui";
import { mapMutations, mapState } from "vuex";
export default {
  // inject
  data() {
    return {
      // 是否正在加载教材列表
      isLoadingTextbooks: false,
      // 教材列表
      textbooks: [],
      // 判断是否自动弹出选择教材
      chooseDialogFlag: false,
    };
  },
  computed: {
    ...mapState({
      // 用户选中的教材列表
      selectedTextbooks: "selectedTextbooks",
      currentCourse: "currentCourse",
    }),
  },
  methods: {
    ...mapMutations({
      setTextbooks: "setTextbooks",
    }),
    //获取用户教材
    async loadTextbooks() {
      // 开始请求教材列表
      this.isLoadingTextbooks = true;
      if (this.currentCourse) {
        // console.log("currentCourse----", this.currentCourse);
        this.textbooks = this.currentCourse.bookList || [];
        this.storeTextbook(this.textbooks);
      }
      // try {
      //   // 获取用户教材
      //   const data = await getUserBooks();
      //   if (data.code === 200) {
      //     this.textbooks = data.result;
      //     // 把获取到的用户教材存储到vuex中
      //     this.storeTextbook(data.result);
      //   } else {
      //     this.storeTextbook([]);
      //   }
      // } catch (error) {
      //   this.storeTextbook([]);
      //   Message({
      //     message: "服务器错误，未获取到用户的教材",
      //     type: "error",
      //     duration: 3 * 1000,
      //   });
      // }
      // 结束请求loading
      this.isLoadingTextbooks = false;
    },
    // 存储用户的教材到vuex中和store中
    storeTextbook(bookList) {
      // console.log("bookList", bookList);
      // 存储用户的教材到vuex的bookList
      this.setTextbooks(bookList);
    },
    // 删除教材
    deleteTextbook(textbookId) {
      return new Promise((resolve, reject) => {
        if (this.selectedTextbooks.length === 1) {
          Message({
            message: "至少需要保留一本教材！",
            type: "error",
            duration: 3 * 1000,
          });
          reject(new Error("至少需要保留一本教材！"));
        }
        this.$confirm("删除教材，是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            try {
              const data = await deleteBook({
                textbookId: parseInt(textbookId),
              });
              if (data.code === 200) {
                Message({
                  message: "删除成功",
                  type: "success",
                  duration: 3 * 1000,
                });
                // 重新加载课程以及教材
                this.loadTextbooks();
                resolve({ code: 200 });
              } else if (data.code === 403 || data.code === 201) {
                Message({
                  message: (data.result && data.result.message) || "删除失败",
                  type: "error",
                  duration: 3 * 1000,
                });
                reject(new Error("删除失败"));
              }
            } catch (error) {
              this.storeTextbook([]);
              Message({
                message: "服务器错误，删除用户教材失败",
                type: "error",
                duration: 3 * 1000,
              });
              reject(new Error("服务器错误，删除用户教材失败"));
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
            reject(new Error("已取消删除"));
          });
      });
    },
    // 打开添加教材弹窗
    openTextbookDialog(triggerType = "主动") {
      // console.log("triggerType", triggerType);
      tracker.handleSendTongji({
        $event_name: "set_textbook_course_popup",
        operate_type: "触发",
        popup_name: "教材设置",
        trigger_type: triggerType,
        xueduan: "",
        xueke: "",
        banben: "",
        cebie: "",
      });
      this.chooseDialogFlag = true;
    },
    // 点击教材跳转到同步页面
    toTechByTextbook(textbook) {
      this.$router.push({
        name: "tech",
        query: util.queryToTechByTextbook(textbook),
      });
    },
    // 获取用户功能模块
    async loadTools(params) {
      // console.log("获取用户功能模块");
      // 获取用户功能模块
      const data = await getUserMode(params);
      if (data.code === 200) {
        return data.result;
      }
    },
  },
};
